import PickupReservation from "routes/Reservation/PickupReservation";
import DeliveryReservation from "routes/Reservation/DeliveryReservation";
import ReservationCompleted from "routes/Reservation/ReservationCompleted";
import ExternalSign from "routes/ExternalSign/ExternalSign";

const reservationRouter = [
    {
        path: "reservation",
        children: [
            {
                path: "pickup/:order_id",
                element: <PickupReservation />,
            },
            {
                path: "delivery/:order_id",
                element: <DeliveryReservation />,
            },
            {
                path: "completed",
                element: <ReservationCompleted />,
            },
        ],
    },
];

export default reservationRouter;
